import { gql } from '@apollo/client';

const SCHEDULE_AGENT_EMAIL = gql`
  mutation scheduleAgentEmail(
    $isTest: Boolean
    $notificationType: NotificationType!
    $overrideSubject: String
    $userId: String!
    $htmlBody: String!
    $templateType: String!
    $scheduledDeliveryAt: DateTime!
  ) {
    scheduleAgentEmail(
      isTest: $isTest
      notificationType: $notificationType
      overrideSubject: $overrideSubject
      userId: $userId
      htmlBody: $htmlBody
      templateType: $templateType
      scheduledDeliveryAt: $scheduledDeliveryAt
    ) {
      success
    }
  }
`;

export default SCHEDULE_AGENT_EMAIL;
